<h2>{{ employee.FirstName }} {{employee.LastName }}'s Attendance for
    {{ Date.pkDate | date: 'mediumDate'}}</h2>


<div *ngIf="!IsTechnical()" class="form-group row">

    <label class="col-sm-3 col-form-label">Arrival</label>
    <div class="col-sm-9 my-1">
        <input type="time" class="form-control" [(ngModel)]="Arrival" id="Arrival" #ArrivalTime="ngModel"
            placeholder="hh:mm:ss">
    </div>

    <label class="col-sm-3 col-form-label">Departure</label>
    <div class="col-sm-9 my-1">
        <input type="time" class="form-control" [(ngModel)]="Departure" id="departure" #DepartureTime="ngModel"
            placeholder="hh:mm:ss">

        <span *ngIf="ArrivalTime.value > DepartureTime.value" class="text-danger">Please enter valid time</span>
    </div>


    <label *ngIf="CheckLeave()" class="col-sm-3 col-form-label">Leave Type</label>
    <div *ngIf="CheckLeave()" class="col-sm-9 my-1">
        <div class="btn-group btn-group-toggle" ngbRadioGroup name="radioBasic" [(ngModel)]="Type">
            <label ngbButtonLabel class="btn-outline-info" data-toggle="tooltip" placement="top"
                ngbTooltip="Casual Balance at the start of month = {{employee.CasualLeaveBalance}}">
                <input ngbButton type="radio" value="Casual">
                Casual
            </label>
            <label ngbButtonLabel class="btn-outline-info" data-toggle="tooltip" placement="top"
                ngbTooltip="Annual Balance at the start of month = {{employee.AnnualLeaveBalance}}">
                <input ngbButton type="radio" value="Annual">
                Annual
            </label>
            <label ngbButtonLabel class="btn-outline-info">
                <input ngbButton type="radio" value="Leave w/o Pay"> Leave w/o Pay
            </label>
        </div>
    </div>


    <div class="col-12 mt-4">
        <div class="d-flex justify-content-end">
            <button (click)="ArrivalTime.value <= DepartureTime.value && UpdateAttendance()"
                *ngIf="attendance != undefined" class="m-1 btn btn-outline-success center">
                Update
            </button>

            <button (click)="DeleteAttendance(attendance.pkAttendanceId)" *ngIf="attendance != undefined"
                class="m-1 btn btn-outline-danger">
                Delete
            </button>

            <button (click)="AddAttendance()" *ngIf="attendance == undefined" class="m-1 btn btn-outline-success">
                Add Attendance
            </button>

            <button (click)="UpdateLeave()" *ngIf="attendance == undefined" class="m-1 btn btn-outline-success">
                Update Leave Type
            </button>

        </div>
    </div>
</div>



<div *ngIf="IsTechnical()" class="form-group">
    <div class="row">
        <label class="col-sm-3 col-form-label">Clockify Minutes</label>
        <div class="col-sm-9">
            <input type="text" class="form-control" [ngModel]="clockifyHours" id="clockifyHours"
                placeholder=" - " disabled>
        </div>
    </div>

    <div class="row">
        <label *ngIf="CheckLeave()" class="col-sm-3 col-form-label">Leave Type</label>
        <div *ngIf="CheckLeave()" class="col-sm-9">
            <div class="btn-group btn-group-toggle" ngbRadioGroup name="radioBasic" [(ngModel)]="Type">
                
                <label ngbButtonLabel class="btn-outline-info" data-toggle="tooltip" placement="top"
                    ngbTooltip="Casual Balance at the start of month = {{employee.CasualLeaveBalance}}">
                    <input ngbButton type="radio" value="Casual">
                    Casual
                </label>
                <label ngbButtonLabel class="btn-outline-info" data-toggle="tooltip" placement="top"
                    ngbTooltip="Annual Balance at the start of month = {{employee.AnnualLeaveBalance}}">
                    <input ngbButton type="radio" value="Annual">
                    Annual
                </label>
                <label ngbButtonLabel class="btn-outline-info">
                    <input ngbButton type="radio" value="Leave w/o Pay"> 
                    Leave w/o Pay
                </label>

            </div>
        </div>
    </div>


    <div class="d-flex justify-content-center mt-4">
        <button (click)="DeleteClockify(clockify.pkId)" *ngIf="clockify != undefined"
            class="m-1 btn btn-outline-danger">
            Delete Attendance
        </button>

        <button (click)="UpdateLeave()" *ngIf="clockify?.WorkHours == undefined" 
            class="m-1 btn btn-outline-success">
            Update Leave Type
        </button>
    </div>
</div>




<button (click)="Test()"></button>